export default __webpack_public_path__ + "static/media/deathgod.5383d3b6.png";